module.exports = __webpack_public_path__ + "static/media/orencash3.1b4a7f24.jpg";